import React from "react";
import StaticPageTemplate, {
  STATIC_PAGE_QUERY,
  StaticPageParams,
} from "components/StaticPageTemplate";
import Layout from "components/common/Layout";
import { getServerSideSEO, SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";

export { STATIC_PAGE_QUERY };

// Remove the unused allowed prop from the interface
export type StaticPageProps = SeoPageProps;

const StaticPage: React.FC<StaticPageProps> = ({ seo }) => (
  <Layout initialMeta={seo}>
    <StaticPageTemplate />
  </Layout>
);

export const getServerSideProps = withEnhancedServerSideProps<StaticPageProps, StaticPageParams>(
  async ctx => {
    const { params } = ctx;
    if (!params?.slug) {
      return { notFound: true } as const;
    }
    const seoData = await getServerSideSEO(ctx, params.slug, "");

    // Remove the unused allowed array from the props
    return { props: seoData };
  }
);

export default StaticPage;
